export default "__VITE_ASSET__BCvob_Mi__"